module.exports = __webpack_public_path__ + "img/team2.ccabe004.png";